
        var result = require("!!../../../../../../../node_modules/css-loader/dist/cjs.js!./Diagram.plain.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    